// xhrInterceptor.js
(function () {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  const wadoRoot = window.config.dataSources[0].configuration['wadoRoot'];

  // Mantém uma referência ao método original para evitar conflitos
  XMLHttpRequest.prototype._originalSetRequestHeader =
    XMLHttpRequest.prototype.setRequestHeader;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._url = url;
    this._headers = {};
    return originalOpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.setRequestHeader = function (header, value) {
    // Garante que o cabeçalho seja registrado internamente e configurado no objeto XMLHttpRequest
    this._headers[header] = value;
    XMLHttpRequest.prototype._originalSetRequestHeader.apply(this, [
      header,
      value,
    ]);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    // Certifica-se de que a URL é válida antes de adicionar o cabeçalho 'Authorization'
    //if (this._url.startsWith(wadoRoot)) {
      const viewerAccessKey = sessionStorage.getItem('viewerAccessKey') + '=';
      if (viewerAccessKey) {
        this.setRequestHeader('Authorization', `Basic ${viewerAccessKey}`);
      }/* else {
        window.ServiceApi.get('Api/Config/GetViewerAccessKey').then(value => {
          if (value) {
            sessionStorage.setItem('viewerAccessKey', value);
            this.setRequestHeader('Authorization', `Basic ${value + '='}`);
          }
        });
      }*/
   // }
    return originalSend.apply(this, args);
  };
})();
